import gql from 'graphql-tag';

const UPDATE_COMERCIAL_POLICY_REFERENCE = gql`
    mutation updateComercialPolicyReference($comercial_policy: Int, $comercial_policy_out: Int) {
        updateComercialPolicyReference(comercial_policy: $comercial_policy, comercial_policy_out: $comercial_policy_out) {
            internalCode
            message
        }
    }
`;

export default UPDATE_COMERCIAL_POLICY_REFERENCE;
